<div style="background-color: #1e1e1e; padding-bottom: 32px" class="user_selection_container">
  <div class="flex justify-between align-center" style="padding: 32px">
    <div style="color: #dedede; font-size: 21px">
      Choose users who can manage this project.
    </div>
    <mat-icon style="width: 13px; height: 13px; color: #dedede" (click)="cancel()">close</mat-icon>
  </div>
  <div style="border-top: 1px solid rgba(222, 222, 222, 0.4)"></div>
  <div style="padding: 20px">
    <div style="margin-left: 10px; color: #dedede">
      {{ selection.selected.length }} Selected
    </div>
    <table mat-table [dataSource]="dataSource" style="width: 100%; background: #1e1e1e; overflow-y: scroll">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <!-- <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td> -->
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>
      <!--      <ng-container matColumnDef="id">-->
      <!--        <th mat-header-cell *matHeaderCellDef>ID</th>-->
      <!--        <td mat-cell *matCellDef="let element"> {{element.id}} </td>-->
      <!--      </ng-container>-->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>
      <ng-container matColumnDef="Full name">
        <th mat-header-cell *matHeaderCellDef>Full name</th>
        <td mat-cell *matCellDef="let element">{{ element.fullName }}</td>
      </ng-container>
      <!-- <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef>firstName</th>
        <td mat-cell *matCellDef="let element"> {{element.firstName}}</td>
      </ng-container>
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef>Last name</th>
        <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
      </ng-container> -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Role</th>
        <td mat-cell *matCellDef="let element">
          <span *ngFor="let role of element.roles">
            {{ role.role }}
          </span>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></tr>
    </table>
  </div>
  <div style="display: flex; justify-content: center; margin-top: 20px">
    <button mat-button style="
        color: #dedede;
        background: #1e1e1e;
        border: 1px solid #dedede;
        width: 90%;
      " (click)="confirm()">
      Confirm
    </button>
  </div>
</div>